import {TicketStatus} from './support-ticket-types'

const canonicalStatuses = new Set<TicketStatus>([
  'Open',
  'CustomerReplied',
  'WaitingForCustomer',
  'PendingClose',
  'Closed',
  'Unknown',
])

const legacyStatuses: Record<string, TicketStatus> = {
  open: 'Open',
  inprogress: 'CustomerReplied',
  customerreplied: 'CustomerReplied',
  waiting: 'WaitingForCustomer',
  waitingcustomer: 'WaitingForCustomer',
  waitingforcustomer: 'WaitingForCustomer',
  resolved: 'PendingClose',
  waitingclose: 'PendingClose',
  pendingclose: 'PendingClose',
  closed: 'Closed',
}

export const canonicalTicketStatus = (value?: string): TicketStatus => {
  if (value && canonicalStatuses.has(value as TicketStatus)) return value as TicketStatus
  const normalized = (value || '').replace(/[\s_-]+/g, '').toLowerCase()
  return legacyStatuses[normalized] || 'Unknown'
}

export const ticketStatusLabel = (status: TicketStatus) => {
  switch (status) {
    case 'CustomerReplied':
      return 'نیازمند پاسخ پشتیبانی'
    case 'WaitingForCustomer':
      return 'در انتظار پاسخ شما'
    case 'PendingClose':
      return 'در انتظار تأیید بستن'
    case 'Closed':
      return 'بسته‌شده'
    case 'Unknown':
      return 'وضعیت نامشخص'
    default:
      return 'باز'
  }
}

export const ticketStatusTone = (status: TicketStatus) => {
  switch (status) {
    case 'PendingClose':
      return 'success'
    case 'WaitingForCustomer':
      return 'warning'
    case 'CustomerReplied':
      return 'info'
    case 'Closed':
      return 'secondary'
    case 'Unknown':
      return 'dark'
    default:
      return 'primary'
  }
}

export const isReplyableStatus = (status: TicketStatus) =>
  status === 'Open' || status === 'CustomerReplied' || status === 'WaitingForCustomer'

export const statusRequiresUserAction = (status: TicketStatus) =>
  status === 'WaitingForCustomer' || status === 'PendingClose'
